import React from "react";
import { useCurrentFrame, interpolate, spring, useVideoConfig } from "remotion";
import type { Platform, Format } from "../styles/theme";

interface CallToActionProps {
  platform: Platform;
  format: Format;
  accentColor?: string;
}

const CTA_TEXT: Record<Platform, string> = {
  youtube: "Subscribe for daily wisdom",
  reels: "Follow for more",
  tiktok: "Follow for wisdom",
};

export const CallToAction: React.FC<CallToActionProps> = ({
  platform,
  format,
  accentColor = "#F37021",
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const enterProgress = spring({
    frame,
    fps,
    config: { damping: 18, stiffness: 120 },
  });

  const opacity = enterProgress;
  const translateY = interpolate(enterProgress, [0, 1], [20, 0]);
  const isPortrait = format === "portrait";

  return (
    <div
      style={{
        position: "absolute",
        bottom: isPortrait ? 200 : 80,
        left: 0,
        right: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 16,
        opacity,
        transform: `translateY(${translateY}px)`,
      }}
    >
      {/* Thin line separator */}
      <div
        style={{
          width: 60,
          height: 1,
          backgroundColor: accentColor,
          opacity: 0.6,
        }}
      />

      {/* CTA text */}
      <div
        style={{
          fontSize: isPortrait ? 20 : 22,
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 500,
          color: "#FFFFFF",
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          opacity: 0.9,
        }}
      >
        {CTA_TEXT[platform]}
      </div>

      {/* Channel name */}
      <div
        style={{
          fontSize: isPortrait ? 14 : 16,
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 400,
          color: accentColor,
          opacity: 0.7,
        }}
      >
        @SriSriRaviShankar
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
